import { render, staticRenderFns } from "./EmergencyInvoice.vue?vue&type=template&id=e1a1a628&scoped=true"
import script from "./EmergencyInvoice.vue?vue&type=script&lang=js"
export * from "./EmergencyInvoice.vue?vue&type=script&lang=js"
import style0 from "./EmergencyInvoice.vue?vue&type=style&index=0&id=e1a1a628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a1a628",
  null
  
)

export default component.exports